<template>
    <div class="row">
        <help-modal/>
        <incomplete-modal/>
        <ModalConnectDocumentContract :contractId="contract.id"  :permissionsAccess="permissionsAccess" :helpName="helpLocations.modalChoseDocumentsToConnect"/>

        <div class="col-12">
            <BasicInformationDisplayBox
                :data="informations"
                :helpName="helpLocations.contractInformation"
                :typesOfContract="typesOfContract"
            />

            <ContractorDisplayBox
                :contractor="contractor"
                :displayDetails="false"
                :helpName="helpLocations.contractor"
                :recipient="recipient"
            />

            <BaseBoxSection :helpName="helpLocations.documentsInContract" :title="__('documents_in_the_contract')">
                <ContractDocumentsTable
                    :documents="contractDocuments"
                    :relatedDocumentTypes="relatedDocumentTypes"
                >
                    <template #default="{checkedDocuments}">
                        <ContractDocumentButtons
                            :permissionsAccess="permissionsAccess"
                            :is-whole-view="isWholeView"
                            :checkedDocuments="checkedDocuments"
                            :contract="informations"
                        />
                    </template>
                </ContractDocumentsTable>
            </BaseBoxSection>

            <AlertBox name="draft_documents_not_included_in_the_settlement"/>

            <ContractSettlement
                :permissionsAccess="permissionsAccess"
                :contract="informations"
                :contractBlanketItemsSummaries="contractBlanketItemsSummaries"
                :contractDetailedItemsSummaries="contractDetailedItemsSummaries"
                :helpName="helpLocations.contractSettlements"
            />

            <div class="row">
                <AttachmentsBox
                    :disabled="true"
                    :downloadLink="downloadLink"
                    :files="files"
                    :helpName="helpLocations.attachments"
                    :permissionsAccess="permissionsAccess"
                />

                <RemarksBox v-model="informations.remarks" :disabled="true" :helpName="helpLocations.remarks"/>
            </div>

            <BaseBoxSection :forForm="false">
                <div class="col-sm-8">
                    <a class="btn btn-white btn-sm" href="/records/contracts">{{ __('return') }}</a>
                </div>
            </BaseBoxSection>
        </div>
    </div>
</template>

<script>

import BasicInformationBox from "../../components/contract-form/BasicInformationBox";
import BasicInformationDisplayBox from "../../components/contract-information/BasicInformationDisplayBox";
import ContractorDisplayBox from "../../components/contract-information/ContractorDisplayBox";
import ContractSettlement from "../../components/contract-information/ContractSettlement";
import AttachmentsBox from "../../components/contract-form/AttachmentsBox";
import hasPermissions from "../../mixins/hasPermissions";
import RemarksBox from "../../components/contract-form/RemarksBox";
import BaseBoxSection from "../../components/BaseBoxSection";
import ContractDocumentsTable from "../../components/tables/contract/ContractDocument/ContractDocumentsTable";
import ContractDocumentButtons from "../../components/tables/contract/ContractDocument/ContractDocumentButtons";
import ModalConnectDocumentContract from "../../components/modals/ModalConnectDocumentContract";
import AlertBox from "../../components/form/AlertBox";

export default {
    name: "ContractInformation",
    components: {
        AlertBox,
        ModalConnectDocumentContract,
        ContractDocumentButtons,
        ContractDocumentsTable,
        BaseBoxSection,
        RemarksBox,
        AttachmentsBox,
        ContractSettlement,
        ContractorDisplayBox,
        BasicInformationDisplayBox,
        BasicInformationBox,
    },
    mixins: [hasPermissions],
    props: {
        contract: {
            type: Object,
            required: true,
        },
        contractDetailedItemsSummaries: {
            type: Object | Array,
            required: true,
        },
        contractBlanketItemsSummaries: {
            type: Object | Array,
            required: true,
        },
        contractDocuments: {
            type: Array,
            required: true,
        },
        typesOfContract: {
            type: Array,
            default: [],
        },
        hasDraftDocuments: {
            type: Boolean,
            required: true,
        },
        helpLocations: {
            type: Object | Array,
            required: true,
        },
        relatedDocumentTypes: {
            type: Array,
            required: true,
        },
        isWholeView: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        informations() {
            return this.contract.informations;
        },
        contractor() {
            return this.contract.contractor;
        },
        recipient() {
            return this.contract.recipient;
        },
        files() {
            return this.contract.files;
        },
        downloadLink() {
            return `/records/contracts/${this.contract.id}/`;
        },
    },
    mounted() {
        if (this.hasDraftDocuments) {
            this.$store.dispatch('addAlert', {
                name: 'draft_documents_not_included_in_the_settlement',
                alert: {
                    type: 'warning',
                    title: this.__('warning'),
                    msg: this.__('there_are_draft_documents_not_included_in_settlement_of_contract'),
                },
            });
        }

        this.$nextTick(() => {
            toggleLoader(false);
        });

    },
};
</script>

